import Swiper, { Navigation, Pagination, Autoplay } from 'swiper'
import { elementsToMaxHeight } from '../helpers/elementsToMaxSizes'


function initBlockSlider() {

  if(!$('.block-hero .swiper').length) return false
  const delay = $('.block-hero').attr('data-autoplay-delay') ? $('.block-hero').attr('data-autoplay-delay') : 4000
  let swiper = new Swiper('.block-hero .swiper', {
    modules: [Navigation, Pagination, Autoplay],
    pagination: {
      el: '.block-hero .swiper-pagination',
      type: 'bullets',
      clickable: true
    },
    loop: true,
    autoplay: {
      delay: delay
    },
    speed: 1200,
    on: {
      afterInit: function () {
        setTimeout(function () {
          elementsToMaxHeight($('.block-hero .swiper-slide .column-container'))
        }, 250)
      }
    }
  })
}


initBlockSlider()
